// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3oYo7","buttons":"PendingPaymentAlert_buttons__2Qn0a"};